/**
 * WorkshopPanel — module for workshop panel UI logic.
 *
 * Currently a lightweight wrapper. The workshop/placement methods remain in UIScene
 * due to deep coupling with UIScene state (phase, resources, placementGhost,
 * workshopPanel container, robotManager, gameScene, etc.). Moving them here
 * would require a massive callback interface with 20+ accessors, providing
 * no net simplification.
 *
 * Methods that belong here conceptually (future extraction candidates):
 * - createWorkshopPanel, createPresetButton, selectPreset
 * - createPlacementGhost, showAnchorZones, clearAnchorZones, cancelPlacement
 * - slideWorkshopPanel, createCancelPlacingButton
 * - placeRobotAt, showCantAffordFeedback, showPlacementError
 * - showCrackedTileRepairPrompt, warnIfBudgetTight
 *
 * To extract: create a WorkshopPanelCallbacks interface similar to
 * RobotInspectorCallbacks, pass UIScene state via getters, and move
 * the method implementations here.
 */
export class WorkshopPanel {
  setup(): void {}
  destroy(): void {}
}
